<payee-popup
  width="480px"
  [onCancel]="onCancel"
>
  <ng-template #payeePopupTitleTemplate>
    <div class="title">
      <payee-icon
        name="refund"
        width="32px"
        height="32px"
      ></payee-icon>
      <h1>{{ dialogData?.transition_label }}</h1>
    </div>
  </ng-template>

  @if (dataLoading()) {
    <div class="dialog-data-loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="48"
      ></mat-progress-spinner>
    </div>
  }

  @if (dialogData && !dataLoading()) {
    <div [formGroup]="form">
      <p class="description">
        {{ "WORKFLOW_DIALOGS.REFUND.COMPLETE_DESCRIPTION" | translate }}
      </p>

      <div class="case-reference">
        <span>{{ "WORKFLOW_DIALOGS.REFUND.CASE_REFERENCE" | translate }}</span>
        <strong>{{ dialogData.case_reference_id }}</strong>
      </div>

      <h2>{{ "WORKFLOW_DIALOGS.REFUND.DETAILS" | translate }}</h2>

      @if (dialogData.fees.length > 0) {
        <div class="fee-list">
          @for (fee of dialogData.fees; track fee.label + fee.currency + fee.amount) {
            <div class="fee-row">
              <span>{{ fee.label }}</span>
              <strong>
                {{ fee.amount | currency: fee.currency : "symbol" : "1.0-0" : "hu" }}
              </strong>
            </div>
          }
        </div>

        <div class="totals">
          <span>{{ "WORKFLOW_DIALOGS.REFUND.TOTAL" | translate }}</span>
          <div>
            @for (total of dialogData.totals; track total.currency) {
              <strong>
                {{ total.amount | currency: total.currency : "symbol" : "1.0-0" : "hu" }}
              </strong>
            }
          </div>
        </div>

        <h2>{{ "WORKFLOW_DIALOGS.REFUND.REFUND_AMOUNT" | translate }}</h2>

        <div
          class="refund-amounts"
          formGroupName="refund_amounts"
        >
          @for (total of dialogData.totals; track total.currency) {
            @let refundControl = refundAmountControl(total.currency);
            <payee-form-field width="max">
              <span payee-label>{{ "WORKFLOW_DIALOGS.REFUND.REFUND_AMOUNT" | translate }}</span>
              <span payee-suffix>{{ total.currency }}</span>
              <input
                payee-input
                type="number"
                [formControlName]="total.currency"
              />
              @if (refundControl?.touched && refundControl?.invalid) {
                <ng-container payee-error>
                  @if (refundControl?.hasError("required")) {
                    <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
                  }
                  @if (refundControl?.hasError("min")) {
                    <span>{{ "WORKFLOW_DIALOGS.REFUND.REFUND_AMOUNT_MIN" | translate }}</span>
                  }
                  @if (refundControl?.hasError("max")) {
                    <span>
                      {{
                        "WORKFLOW_DIALOGS.REFUND.REFUND_AMOUNT_MAX"
                          | translate
                            : {
                                max: refundControl?.errors?.max?.max | number: "1.0-0" : "hu",
                                currency: total.currency,
                              }
                      }}
                    </span>
                  }
                </ng-container>
              }
            </payee-form-field>
          }
        </div>
      } @else {
        <p class="empty-state">
          {{ "WORKFLOW_DIALOGS.REFUND.NO_FEES" | translate }}
        </p>
      }

      <payee-workflow-provided-media [transitionWithDialog]="data"></payee-workflow-provided-media>

      <h2>{{ "WORKFLOW_DIALOGS.REFUND.FILE_UPLOAD" | translate }}</h2>

      <payee-dropzone
        width="max"
        [title]="dropzoneTitle"
        [isDisabled]="files.value.length >= 10"
        (dropped)="onDrop($event)"
      ></payee-dropzone>

      <div class="files-list">
        @for (file of files.value; track $index; let fileIndex = $index) {
          <div class="file-item flex vcenter">
            <div class="file-status">
              <payee-icon name="checkmark-darker-green-circle"></payee-icon>
            </div>
            <div class="file-name">{{ file.name }}</div>
            <button
              payee-icon-button
              color="white"
              class="file-delete-button"
              (click)="removeFile(fileIndex)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
        }
      </div>

      @if (files.touched && files.hasError("minTotalFiles")) {
        <p class="files-error">
          {{ "WORKFLOW_DIALOGS.REFUND.FILES_MIN" | translate: { count: files.errors?.minTotalFiles?.required } }}
        </p>
      }
    </div>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="dataLoading() || loading || dialogData === undefined"
      [loading]="loading"
      (click)="onSubmit()"
    >
      {{ "WORKFLOW_DIALOGS.REFUND.COMPLETE_SUBMIT" | translate }}
    </button>
  </ng-template>
</payee-popup>
